import axios from "axios";
import { from, of } from "rxjs";
import { map, catchError, first } from 'rxjs/operators';
import queryString from "query-string";

const currentDomain = window.location.protocol + "//"+ window.location.host;

export const logInUser = (params) => {
  if( !params || !params.email || !params.password ){
    return of( { "response" : "failure", "message" : "Enter login details." } );
  }
  params.domainSetting = process.env['REACT_APP_API_URL'];
  params.withCredentials = true;
  return from (
    axios.post(process.env['REACT_APP_API_URL'] + '/upward/employee/login_json.jsp', queryString.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
   })
  ).pipe(
    first(),
    map( (response) => {
      if (response.data && response.data.loginStatus === 'success') {
        return { "response" : "success", "message" : "" }
      } else {
        return ({ "response": "failure", "message": "Invalid login credentials." });
      }
    }),
    catchError((err) => { console.log(err); return of({ "response": "failure", "message": "Try again." } ) } )
  )
}

export const resetUserPassword = (params) => {
  if( !params || !params.email ){
    return of( { "response" : "failure", "message" : "Enter login details." } );
  }
  params.creativeId = 72;
  params.siteId = 71;
  return from (
    axios.post(process.env['REACT_APP_API_URL'] + '/upward/employee/systemEmail.jsp', queryString.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
   })
).pipe(
    first(),
    map( (response) => {
      if (response.data && response.data === 1) {
        return { "response" : "success", "message" : "You should receive a password reset email in the next 15 minutes." }
      } else {
        return ({ "response": "failure", "message": "Invalid Email." });
      }
    }),
    catchError((err) => { console.log(err); return of({ "response": "failure", "message": "Try again." } ) } )
  )
}
